import { Dialog as MuiDialog } from '@mui/material';

import { DialogProps } from './Dialog';
import DialogInner from './DialogInner';

export default function SimpleDialog({ title, children, onClose, actions, size, subtitle, ...props }: Omit<DialogProps, 'variant'> & { size: 'xs' | 'sm' | 'md' }) {
    return (
        <MuiDialog maxWidth={ size }
            fullWidth
            onClose={ onClose }
            { ...props }
        >
            <DialogInner title={ title }
                onClose={ onClose }
                actions={ actions }
                subtitle={ subtitle }
            >
                { children }
            </DialogInner>
        </MuiDialog>
    );
}
